let handleOutsideClick
let clickedForTheFirstTime = true

module.exports = {
    bind(el, binding, vnode) {
        handleOutsideClick = (e) => {
            if (!el.contains(e.target) && !clickedForTheFirstTime) {
                binding.value()
            }
            clickedForTheFirstTime = false;
        }        
        document.addEventListener('click', handleOutsideClick)
        document.addEventListener('touchstart', handleOutsideClick)
    },
    unbind() {
        clickedForTheFirstTime = true
        document.removeEventListener('click', handleOutsideClick)
        document.removeEventListener('touchstart', handleOutsideClick)
    }
}


//////////////////
// WEBPACK FOOTER
// ../raypro_ui/src/directives/clickOutside.js
// module id = v0jY
// module chunks = 0